import { initStore } from "./store";

const configureStore = () => {
  const actions = {
    SET_MLSPEECHTEXT: (state, payload) => {
      return { 
        // ...state,
        mlSpeechStore : {
          ...state.mlSpeechStore,
          mlSpeechText: payload, 
        }
      };
    },
    SET_MLSPEECHCURRENTAUDIODATA: (state, payload) => {
      return { 
        // ...state,
        mlSpeechStore : {
          ...state.mlSpeechStore,
          mlSpeechCurrentAudioData: payload, 
        }
      };
    },
    SET_MLSPEECHINPUTFILENAME: (state, payload) => {
      return { 
        // ...state,
        mlSpeechStore : {
          ...state.mlSpeechStore,
          mlSpeechInputFileName: payload, 
        }
      };
    },
    SET_MLSPEECHSRTTEXT: (state, payload) => {
      return { 
        // ...state,
        mlSpeechStore : {
          ...state.mlSpeechStore,
          mlSpeechSrtText: payload, 
        }
      };
    },
    SET_MLSPEECHMODELS: (state, payload) => {
      return { 
        // ...state,
        mlSpeechStore : {
          ...state.mlSpeechStore,
          mlSpeechModels: payload, 
        }
      };
    },
    SET_MLSPEECHSELECTEDLANGUAGE: (state, payload) => {
      return { 
        // ...state,
        mlSpeechStore : {
          ...state.mlSpeechStore,
          mlSpeechSelectedLanguage: payload, 
        }
      };
    },
    SET_MLSPEECHSELECTEDMODEL: (state, payload) => {
      return { 
        // ...state,
        mlSpeechStore : {
          ...state.mlSpeechStore,
          mlSpeechSelectedModel: payload, 
        }
      };
    },
    SET_MLSPEECHTOTEXTCONFIG: (state, payload) => {
      return { 
        // ...state,
        mlSpeechStore : {
          ...state.mlSpeechStore,
          mlSpeechToTextConfig: payload, 
        }
      };
    },
    SET_MLSPEECHISUSERGENERATING: (state, payload) => {
      return { 
        // ...state,
        mlSpeechStore : {
          ...state.mlSpeechStore,
          mlSpeechIsUserGenerating: payload, 
        }
      };
    },
    SET_MLSPEECHISSERVERBUSY: (state, payload) => {
      return { 
        // ...state,
        mlSpeechStore : {
          ...state.mlSpeechStore,
          mlSpeechIsServerBusy: payload, 
        }
      };
    },
    SET_MLSPEECHISSERVER: (state, payload) => {
      return { 
        // ...state,
        mlSpeechStore : {
          ...state.mlSpeechStore,
          mlSpeechIsServer: payload, 
        }
      };
    },
  };

  initStore(actions, {
    mlSpeechStore: {
      mlSpeechText: null,  
      mlSpeechCurrentAudioData: null,
      mlSpeechInputFileName: '',
      mlSpeechSrtText: '',
      mlSpeechModels: null,
      mlSpeechSelectedLanguage: '',
      mlSpeechSelectedModel: '',
      mlSpeechToTextConfig: null,
      mlSpeechIsUserGenerating: false,
      mlSpeechIsServerBusy: false,
      mlSpeechIsServer: false,
    }
  });
};

export default configureStore;
